import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import { useSelector } from 'react-redux';

// HERO
import directCallHero from '../../assets/images/b2bDirectCall/HeroB2BDirectCall.jpg';

// SECTION IMAGES
import globalDatabase from '../../assets/images/b2bDirectCall/DatabaseIntro.jpg';
import countryTarget from '../../assets/images/b2bDirectCall/GeoTargeting.jpg';
import b2bNetwork from '../../assets/images/b2bDirectCall/BusinessLead.jpg';
import teamSupport from '../../assets/images/b2bDirectCall/bgTradeShow.jpg';


const B2BDirectCallPage = () => {
  const isIta = useSelector((state) => state.createUser.languageIta);

  return (
    <MainLayout>
      <div className='bg-light' style={{ maxHeight: "calc(100vh - 59px)", overflowY: "scroll" }}>

        {/* HERO */}
        <div
          className='text-center myBgImgCover'
          style={{ backgroundImage: `url(${directCallHero})` }}
        >
          <div className='px-4 py-5 myBgTransparent60 text-light d-flex flex-column align-items-center'>
            <h1 className='montserrat-alternates-bold'>
              B2B Direct Call
            </h1>

            <h2 className='font-nycd text-info my-5'>
              {isIta
                ? 'CONNECTING MANUFACTURERS WITH THE RIGHT BUSINESS PARTNERS'
                : 'CONNECTING MANUFACTURERS WITH THE RIGHT BUSINESS PARTNERS'}
            </h2>

            <h3 className='fw-light myMaxWidth1200'>
              {isIta
                ? "Il servizio B2B Direct Call è pensato per supportare le aziende nella ricerca di nuovi distributori e business partner all'interno di mercati strategici. Il nostro team contatta direttamente i distributori selezionati dal nostro database internazionale, presentando la tua azienda e aprendo la strada a nuove opportunità commerciali."
                : "Our B2B Direct Call service is designed to support companies in identifying new distributors and business partners within strategic markets. Our team directly contacts selected distributors from our international database, presents your company, and helps open the door to new business opportunities."}
            </h3>
          </div>
        </div>

        {/* INTRO */}
        <div className='p-3 pt-5 myBgLightGray'>
          <div className='spacerLg'></div>

          <div className='d-flex flex-wrap justify-content-around align-items-center gap-5'>
            <div>

              <h2 className='montserrat-alternates-bold text-secondary mb-4'>
                {isIta ? 'Dai Contatti al Business' : 'From Contacts to Business'}
              </h2>
              <h3 className='text-secondary myMaxWidth700 fw-normal'>
                {isIta ? (
                  <div>
                    Entrare in nuovi mercati richiede molto più di un semplice database. Richiede
                    <b> contatto diretto</b>, capacità di presentazione e un approccio professionale capace di
                    trasformare un nominativo in una conversazione concreta. Con <b>B2B Direct Call</b>,
                    il nostro team svolge attività di outreach telefonico mirato verso i distributori più rilevanti,
                    con l’obiettivo di generare <b>qualified leads</b> e favorire connessioni di valore tra la tua
                    azienda e potenziali partner commerciali.
                  </div>
                ) : (
                  <div>
                    Entering new markets requires far more than a simple database. It requires
                    <b> direct outreach</b>, a strong presentation capability and a professional approach able to
                    turn a name into a meaningful business conversation. With <b>B2B Direct Call</b>,
                    our team carries out targeted phone outreach to the most relevant distributors, with the goal
                    of generating <b>qualified leads</b> and creating valuable connections between your company
                    and potential business partners.
                  </div>
                )}
              </h3>
            </div>

            <img className='w-100 myMaxWidth700 rounded-4 shadow' src={globalDatabase} alt="global database" />
          </div>

          <div className='spacerLg'></div>
        </div>

        {/* HOW IT WORKS */}
        <div className='p-4 pt-5 text-secondary'>
          <div className='spacerLg'></div>

          <div className='text-center mb-5'>
            <h2 className='montserrat-alternates-bold'>
              {isIta ? 'Un approccio strutturato, mercato per mercato' : 'A structured approach, market by market'}
            </h2>
          </div>

          <div className='d-flex flex-wrap justify-content-center gap-4'>

            <div
              className='bg-white shadow-sm rounded-4 p-4 text-center'
              style={{ maxWidth: "320px", flex: "1 1 260px" }}
            >
              <i className="bi bi-geo-alt-fill text-info" style={{ fontSize: "2.4rem" }}></i>
              <h4 className='mt-3'>
                {isIta ? 'Target geografico' : 'Geographic targeting'}
              </h4>
              <div className='fw-light'>
                {isIta
                  ? 'L’attività viene pianificata in base al paese, all’area geografica o alla regione di tuo interesse.'
                  : 'The activity is planned according to the country, geographic area or region you want to target.'}
              </div>
            </div>

            <div
              className='bg-white shadow-sm rounded-4 p-4 text-center'
              style={{ maxWidth: "320px", flex: "1 1 260px" }}
            >
              <i className="bi bi-database-fill-check text-info" style={{ fontSize: "2.4rem" }}></i>
              <h4 className='mt-3'>
                {isIta ? 'Selezione dei contatti' : 'Contact selection'}
              </h4>
              <div className='fw-light'>
                {isIta
                  ? 'Il nostro team individua i distributori presenti nel database in linea con il mercato scelto.'
                  : 'Our team identifies distributors within the database according to the selected market.'}
              </div>
            </div>

            <div
              className='bg-white shadow-sm rounded-4 p-4 text-center'
              style={{ maxWidth: "320px", flex: "1 1 260px" }}
            >
              <i className="bi bi-telephone-outbound-fill text-info" style={{ fontSize: "2.4rem" }}></i>
              <h4 className='mt-3'>
                {isIta ? 'Presentazione diretta' : 'Direct presentation'}
              </h4>
              <div className='fw-light'>
                {isIta
                  ? 'Un operatore specializzato contatta telefonicamente i distributori per presentare la tua azienda e il tuo interesse ad aprire nuove collaborazioni.'
                  : 'A specialized operator directly contacts distributors by phone to introduce your company and your interest in establishing new partnerships.'}
              </div>
            </div>

            <div
              className='bg-white shadow-sm rounded-4 p-4 text-center'
              style={{ maxWidth: "320px", flex: "1 1 260px" }}
            >
              <i className="bi bi-person-check-fill text-info" style={{ fontSize: "2.4rem" }}></i>
              <h4 className='mt-3'>
                {isIta ? 'Lead qualificati' : 'Qualified leads'}
              </h4>
              <div className='fw-light'>
                {isIta
                  ? 'I contatti interessati vengono raccolti e condivisi per facilitare il tuo follow-up commerciale.'
                  : 'Interested contacts are collected and shared with you to facilitate your commercial follow-up.'}
              </div>
            </div>

          </div>

          <div className='spacerLg'></div>
        </div>

        {/* MARKET FOCUS */}
        <div className='myBgLightGray'>
          <div className='spacerLg'></div>

          <div className='d-flex flex-wrap justify-content-around align-items-center gap-5 p-3 pt-4'>
            <img className='w-100 myMaxWidth700 rounded-4' src={countryTarget} alt="market targeting" />
            <div>
              <h2 className='montserrat-alternates-bold text-secondary mb-4'>
                {isIta ? 'Espansione nei Mercati' : 'Market Expansion'}
              </h2>
              <h2 className='text-secondary myMaxWidth700 fw-normal'>
                {isIta ? (
                  <div>
                    Il servizio è acquistabile in funzione del <b>mercato da presidiare</b>. Questo significa
                    che la tua attività di outreach può essere concentrata su uno specifico paese o su una determinata
                    regione strategica. Se il tuo obiettivo è, ad esempio, rafforzare la presenza in Cina, il nostro team
                    contatterà i distributori localizzati in quell’area per presentare la tua azienda e sondare l’interesse
                    verso una potenziale collaborazione.
                  </div>
                ) : (
                  <div>
                    The service can be purchased according to the <b>market you want to develop</b>. This means your
                    outreach activity can be focused on a specific country or a selected strategic region. If your goal,
                    for example, is to strengthen your presence in China, our team will contact distributors located in that
                    area to present your company and assess their interest in a potential partnership.
                  </div>
                )}
              </h2>
            </div>
          </div>

          <div className='spacerLg'></div>
        </div>

        {/* VALUE PROPOSITION */}
        <div className='p-4 pt-5'>
          <div className='spacerLg'></div>

          <div className='text-center mb-5'>
            <h2 className='montserrat-alternates-bold text-secondary'>
              {isIta ? 'Perché questo servizio fa la differenza' : 'Why this service makes a difference'}
            </h2>
          </div>

          <div className='d-flex flex-wrap justify-content-center gap-4'>

            <div
              className='bg-white shadow-sm rounded-4 p-4 text-center'
              style={{ maxWidth: "360px", flex: "1 1 280px" }}
            >
              <i className="bi bi-people-fill text-info" style={{ fontSize: "2.2rem" }}></i>
              <h4 className='mt-3 text-secondary'>
                {isIta ? 'Human-to-human connection' : 'Human-to-human connection'}
              </h4>
              <div className='text-secondary'>
                {isIta
                  ? 'La telefonata diretta crea una relazione iniziale più forte, più memorabile e più autorevole rispetto a un contatto impersonale.'
                  : 'A direct phone call creates a stronger, more memorable and more authoritative first interaction than impersonal communication.'}
              </div>
            </div>

            <div
              className='bg-white shadow-sm rounded-4 p-4 text-center'
              style={{ maxWidth: "360px", flex: "1 1 280px" }}
            >
              <i className="bi bi-bullseye text-info" style={{ fontSize: "2.2rem" }}></i>
              <h4 className='mt-3 text-secondary'>
                {isIta ? 'Outreach mirato' : 'Targeted outreach'}
              </h4>
              <div className='text-secondary'>
                {isIta
                  ? 'L’attività si concentra sui distributori localizzati nel mercato che desideri sviluppare, con un approccio coerente con i tuoi obiettivi commerciali.'
                  : 'The activity focuses on distributors located in the market you want to develop, with an approach aligned with your business goals.'}
              </div>
            </div>

            <div
              className='bg-white shadow-sm rounded-4 p-4 text-center'
              style={{ maxWidth: "360px", flex: "1 1 280px" }}
            >
              <i className="bi bi-graph-up-arrow text-info" style={{ fontSize: "2.2rem" }}></i>
              <h4 className='mt-3 text-secondary'>
                {isIta ? 'Supporto allo sviluppo internazionale' : 'Support for international growth'}
              </h4>
              <div className='text-secondary'>
                {isIta
                  ? 'Ti aiutiamo a costruire una pipeline di contatti utili per l’espansione commerciale e l’ingresso in nuovi mercati.'
                  : 'We help you build a pipeline of valuable contacts to support commercial expansion and entry into new markets.'}
              </div>
            </div>

          </div>

          <div className='spacerLg'></div>
        </div>

        {/* BUSINESS IMPACT */}
        <div className='p-3 pt-5 bg-dark text-light'>
          <div className='spacerLg'></div>

          <div className='d-flex flex-wrap justify-content-around align-items-center gap-5'>

            <div>
              <h2 className='montserrat-alternates-bold mb-4'>
                {isIta ? 'Contatti Qualificati' : 'Qualified Contacts'}
              </h2>
              <h2 className='myMaxWidth700 fw-normal'>
                {isIta ? (
                  <div>
                    Il valore del servizio non sta solo nella chiamata, ma nella capacità di
                    <b> attivare un primo contatto qualificato</b> tra la tua azienda e potenziali business partner.
                    Questo consente al tuo team commerciale di lavorare su contatti già introdotti, già sensibilizzati
                    e più pronti a proseguire la conversazione in modo strutturato.
                  </div>
                ) : (
                  <div>
                    The value of the service does not lie in the call itself, but in its ability to
                    <b> activate a qualified first contact</b> between your company and potential business partners.
                    This enables your sales team to work with contacts who have already been introduced to your brand
                    and are better prepared for a structured follow-up conversation.
                  </div>
                )}
              </h2>
            </div>

            <img className='w-100 myMaxWidth700 rounded-4 shadow' src={b2bNetwork} alt="business network" />
          </div>

          <div className='spacerLg'></div>
        </div>

        {/* CTA */}
        <div className='p-4 d-flex flex-column align-items-center'>
          <div className='spacerLg'></div>

          <div className='d-flex flex-wrap justify-content-center gap-5 py-5 pt-5'>
            <i className="bi bi-globe2 text-info" style={{ fontSize: "3rem" }}></i>
            <i className="bi bi-telephone-forward-fill text-info" style={{ fontSize: "3rem" }}></i>
            <i className="bi bi-diagram-3-fill text-info" style={{ fontSize: "3rem" }}></i>
          </div>

          <h2 className='text-secondary text-center myMaxWidth1200'>
            {isIta ? (
              <div>
                Se stai cercando un modo più diretto, più autorevole e più efficace per entrare in contatto
                con distributori internazionali, <b>B2B Direct Call</b> è il servizio che ti permette di trasformare
                la ricerca di partner in un’attività concreta di business development.
              </div>
            ) : (
              <div>
                If you are looking for a more direct, authoritative and effective way to connect with international
                distributors, <b>B2B Direct Call</b> is the service that turns partner search into a practical
                business development activity.
              </div>
            )}
          </h2>

          <h1 className='font-nycd mt-5 mb-4 text-center fw-light text-info'>
            {isIta
              ? 'Expand your reach. Build the right connections.'
              : 'Expand your reach. Build the right connections.'}
          </h1>

          <div className='spacerLg'></div>
        </div>

        {/* FINAL SECTION */}
        <div
          className='text-center myBgImgCover'
          style={{ backgroundImage: `url(${teamSupport})` }}
        >
          <div className='p-4 myBgTransparent60 text-light d-flex flex-column align-items-center'>
            <h2 className='fw-light my-5 myMaxWidth1200'>
              {isIta ? (
                <div>
                  Dalla selezione del mercato fino al contatto diretto con i distributori, il nostro team
                  gestisce ogni fase con un approccio professionale, discreto e orientato al risultato,
                  aiutandoti a sviluppare nuove connessioni commerciali nei mercati più rilevanti per il tuo business.
                </div>
              ) : (
                <div>
                  From market selection to direct distributor outreach, our team manages every phase with
                  a professional, discreet and results-oriented approach, helping you develop new commercial
                  connections in the markets that matter most to your business.
                </div>
              )}
            </h2>

          </div>
        </div>

      </div>
    </MainLayout>
  );
};

export default B2BDirectCallPage;